export default {
  confirmPasswordError: 'Las contraseñas no coinciden.',
};
